// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopApparelSection_container__JfZ46","title":"ShopApparelSection_title___AU5T"};